import React from "react";
import { Form, Label, FormGroup } from "reactstrap";
import PropTypes from "prop-types";
import { FormField, CheckFormField, SelectFormField } from "../../../../../utils/FormFields";
import translate from "../../../../../utils/Translator";

const HoldersTab = ({ account, changedAccount, showChanges }) => {
  const editHolder = changedAccount.Holder[0];
  let compareHolder;
  account.Holder.map((h) => {
    if (parseInt(h.PersonId, 10) === parseInt(editHolder.PersonId, 10)) {
      compareHolder = h;
    }
    return {};
  });
  let color = "black";
  if (showChanges) {
    if (compareHolder && editHolder.deleteHolder) {
      color = "red";
    } else if (compareHolder) {
      color = "#36a9e1";
    } else {
      color = "green";
    }
  }
  return (
    <Form>
      <Label
        style={{
          fontWeight: 500,
          fontSize: "20px",
          display: "block",
          color,
        }}
      >
        {showChanges ? (
          <React.Fragment>
            {compareHolder ? (
              <React.Fragment>{editHolder.deleteHolder ? "Remove Holder" : "Edit Holder"}</React.Fragment>
            ) : (
              "New Holder"
            )}
          </React.Fragment>
        ) : (
          `Actual ${translate("Account")}`
        )}
      </Label>
      {showChanges ? (
        <FormGroup tag="fieldset">
          {!editHolder.deleteHolder && (
            <FormToShow
              holder={editHolder}
              isPhysical={account.AccountIsPhysical}
              refHolder={compareHolder}
            />
          )}
        </FormGroup>
      ) : (
        <FormGroup tag="fieldset">
          {compareHolder && <FormToShow holder={compareHolder} isPhysical={account.AccountIsPhysical} />}
        </FormGroup>
      )}
    </Form>
  );
};

HoldersTab.propTypes = {
  changedAccount: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  showChanges: PropTypes.bool.isRequired,
};

export default HoldersTab;

const FormToShow = ({ holder, isPhysical = true, refHolder }) => (
  <React.Fragment>
    <FormField
      name="PersonId"
      value={holder.PersonName}
      label="Holder"
      changedColor={refHolder && parseInt(holder.PersonId, 10) !== parseInt(refHolder.PersonId, 10)}
    />
    {isPhysical ? (
      <React.Fragment>
        <FormField
          name="HoldersRelationship"
          value={holder.HoldersRelationship}
          label={`${translate("Account")} Relationship`}
          changedColor={refHolder && holder.HoldersRelationship !== refHolder.HoldersRelationship}
        />
        <CheckFormField
          initialValue={holder.isMainHolder}
          name="isMainHolder"
          value={holder.isMainHolder}
          disabled
          label="is Main Holder"
          changedColor={refHolder && holder.isMainHolder !== refHolder.isMainHolder}
        />
        {holder.AccountHolderPersonType == "Physical" && (
          <CheckFormField
            initialValue={holder.AccountHolderIsBeneficiary}
            name="AccountHolderIsBeneficiary"
            value={holder.AccountHolderIsBeneficiary}
            disabled
            label="is Beneficiary"
            changedColor={
              refHolder && holder.AccountHolderIsBeneficiary !== refHolder.AccountHolderIsBeneficiary
            }
          />
        )}
      </React.Fragment>
    ) : (
      <React.Fragment>
        <FormField
          name="HoldersRelationshipJuridical"
          value={holder.HoldersRelationshipJuridical}
          label={`${translate("Account")} Relationship`}
          changedColor={
            refHolder && holder.HoldersRelationshipJuridical !== refHolder.HoldersRelationshipJuridical
          }
        />
        <CheckFormField
          initialValue={holder.HoldersIsController}
          name="HoldersIsController"
          value={holder.HoldersIsController}
          label="is Controller"
          disabled
          changedColor={refHolder && holder.HoldersIsController !== refHolder.HoldersIsController}
        />
        <CheckFormField
          initialValue={holder.HoldersIsManager}
          name="HoldersIsManager"
          value={holder.HoldersIsManager}
          disabled
          label="is Manager"
          changedColor={refHolder && holder.HoldersIsManager !== refHolder.HoldersIsManager}
        />
        {holder.PersonType === "Juridical" && (
          <CheckFormField
            name="isMainHolder"
            value={holder.isMainHolder}
            disabled
            initialValue={holder.isMainHolder}
            label="is Main Holder"
          />
        )}
      </React.Fragment>
    )}
    <SelectFormField
      label="Authorization Managed: "
      changedColor={
        refHolder && parseInt(holder.HoldersOrderManaged, 10) !== parseInt(refHolder.HoldersOrderManaged, 10)
      }
      value={holder.HoldersOrderManaged ? "1" : "0"}
      selectItems={[1, 0]}
      getSelectItemId={(i) => i}
      getSelectItemName={(i) => (i === 1 ? "Yes" : "No")}
      name="HoldersOrderManaged"
      disabled
    />
    <SelectFormField
      label="Authorization Written: "
      changedColor={
        refHolder && parseInt(holder.HoldersOrderWritten, 10) !== parseInt(refHolder.HoldersOrderWritten, 10)
      }
      value={holder.HoldersOrderWritten ? "1" : "0"}
      selectItems={[1, 0]}
      getSelectItemId={(i) => i}
      getSelectItemName={(i) => (i === 1 ? "Yes" : "No")}
      name="HoldersOrderWritten"
      disabled
    />
    <SelectFormField
      label="Authorization Web: "
      chagedColor={
        refHolder && parseInt(holder.HoldersOrderWeb, 10) !== parseInt(refHolder.HoldersOrderWeb, 10)
      }
      value={holder.HoldersOrderWeb ? "1" : "0"}
      selectItems={[1, 0]}
      getSelectItemId={(i) => i}
      getSelectItemName={(i) => (i === 1 ? "Yes" : "No")}
      name="HoldersOrderWeb"
      disabled
    />
    <SelectFormField
      label="Authorization Via Link: "
      changedColor={
        refHolder && parseInt(holder.HoldersOrderViaLink, 10) !== parseInt(refHolder.HoldersOrderViaLink, 10)
      }
      value={holder.HoldersOrderViaLink ? "1" : "0"}
      selectItems={[1, 0]}
      getSelectItemId={(i) => i}
      getSelectItemName={(i) => (i === 1 ? "Yes" : "No")}
      name="HoldersOrderViaLink"
      disabled
    />
  </React.Fragment>
);

FormToShow.propTypes = {
  holder: PropTypes.object.isRequired,
  isPhysical: PropTypes.bool.isRequired,
  refHolder: PropTypes.object,
};

FormToShow.defaultProps = {
  refHolder: undefined,
};
